<template>
  <div>
    <v-dialog
      v-show="addTeamMemberDialog"
      v-model="addTeamMemberDialog"
      persistent
      max-width="800px"
      v-scroll-lock="!addTeamMemberDialog"
    >
      <v-card>
        <v-card-text class="justify-center pb-1 pl-10" v-if="isMasterAccount">
          <v-row class="pt-4">
            <v-col cols="6" class="d-flex align-center">
              <v-text-field
                placeholder="type email address here..."
                outlined
                dense
                name="email"
                :hide-details="true"
                v-model="email"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex align-center">
              <v-btn
                @click.stop="addMember()"
                color="success"
                :disabled="newMailRules"
              >
                Add member
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-simple-table
          fixed-header
          height="300px"
          class="ml-10 mr-10 pt-4 mb-3"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>Name</th>
                <th>Account ID</th>
                <th>Email</th>
                <th v-if="isMasterAccount"></th>
              </tr>
            </thead>
            <tbody v-if="team && team.Members">
              <tr v-for="(member, index) in team.Members" :key="index">
                <td style="font-size: 18px; pointer-events: none;">
                  {{ member.Name }}
                </td>
                <td style="font-size: 15px; pointer-events: none;">
                  {{ member.Sub }}
                </td>
                <td style="font-size: 15px; pointer-events: none;">
                  {{ member.Email }}
                </td>
                <td v-if="isMasterAccount">
                  <v-btn
                    v-if="member.Sub !== myPlan.MasterAccountId"
                    color="error"
                    text
                    @click="removeTeamMember(member.Email)"
                  >
                    Remove
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row
          class="justify-space-between"
          style="margin-left: 30px; margin-right: 30px;"
        >
          <v-btn
            class="mb-5"
            color="error"
            @click="setAddTeamMemberDialog(false)"
          >
            Close
          </v-btn>
          <v-btn
            color="error"
            style="pointer-events: fill;"
            @click="dismissTeam()"
            v-if="isMasterAccount"
          >
            Delete team
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingTeam" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Now processing...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'AddTeamMemberDialog',
  components: {
    ConfirmDialog,
  },
  props: {
    addTeamMemberDialog: {
      type: Boolean,
      default: false,
    },
    team: {
      type: Object,
      default: null,
    },
    myPlan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingTeam: false,
      email: '',
    }
  },
  methods: {
    setAddTeamMemberDialog(show) {
      this.$emit('setAddTeamMemberDialog', show)
    },
    async addMember() {
      this.loadingTeam = true
      await this.postTeamMember(this.email)
      await this.$emit('reloadTeamInfo')
      this.email = ''
      this.loadingTeam = false
      // this.$emit('setAddTeamMemberDialog', false)
    },
    async dismissTeam() {
      if (
        await this.$refs.confirm.open(
          'You are attempting to delete a team. <br>This operation cannot be undone.',
          'Continue'
        )
      ) {
        this.loadingTeam = true
        await this.deleteTeam()
        this.loadingTeam = false
        this.$emit('init')
        this.$emit('setAddTeamMemberDialog', false)
      }
    },
    async removeTeamMember(email) {
      this.loadingTeam = true
      await this.deleteTeamMember(email)
      await this.$emit('reloadTeamInfo')
      this.loadingTeam = false
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    isMasterAccount() {
      if (this.user && this.user.username) {
        return this.myPlan.MasterAccountId === this.user.username
      }
      return false
    },
    newMailRules() {
      return /.+@.+\..+/.test(this.email) ? false : true
    },
  },
  mounted() {},
}
</script>

<style scoped>
.v-data-table__wrapper th {
  font-size: 18px;
  color: #00bfff !important;
}
.v-data-table >>> tbody tr:hover:not(.v-data-table__expanded__content) {
  background: #ffffff !important;
}
</style>
